import { useRef, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import OptionsCard from "components/OptionsCard/OptionsCard";

const MenuCell: FC<Props> = ({
  element,
  onAddToDossier,
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const refWrapper = useRef<HTMLDivElement>(null);

  return (
    <div className={styles.cell}>
      <div
        onClick={() => {
          setShowOptions(!showOptions);
        }}
        ref={refWrapper}
        className={styles.hover}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </div>
      <OptionsCard
        selectedElements={[]}
        binds
        toggle={() => setShowOptions(false)}
        showOptions={showOptions}
        pack={element}
        refetch={() => {}}
        refWrapper={refWrapper}
        onClickAttachIcon={() => {}}
        isCase
        isRightClicked
        dropdown
        setShowAddToDossier={() => {
          onAddToDossier(element);
        }}
      />
    </div>
  );
};

export default MenuCell;
